import loadable from '@loadable/component';

export const ActivateInsuranceLoadable = loadable(() => import('./ActivateInsurance'), {
  fallback: undefined,
  ssr: false,
});
